import axios from 'axios'
import { API_KEY, API_URL } from '../keys'

export const fetchSales = async (token: string, from: string, to: string) => {
	try {
		const response = await axios.get(`${API_URL}/sales`, {
			headers: {
				Authorization: `Bearer ${token}`,
				'sce-api-users-key-validation': API_KEY,
				'Content-Type': 'application/json',
			},
			params: {
				from,
				to,
			},
			validateStatus: (status) => status < 500,
		})

		return response
	} catch (error) {
		console.error('Error fetching sales:', error)
		throw error
	}
}
